// extracted by mini-css-extract-plugin
module.exports = {"kitA":"kitA_kitA__H33mO"};